import { render, staticRenderFns } from "./SharedDocsRow.vue?vue&type=template&id=7b85bb2a&"
import script from "./SharedDocsRow.vue?vue&type=script&lang=js&"
export * from "./SharedDocsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports